import { useState, useEffect, useCallback } from 'react';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import { getSubscribeTexts } from '@/creditflowresearch/ui/components/deals/helpers';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';

export interface ISubscriptionProps {
  subscriptionId: string,
  subscriptionSubgroupName: string,
  subscriptionName: string,
  isSubscribed: boolean,
  subscriptionRequiredPlan: UserPlanType,
}

export const useDealSubscriptions = (subscriptionStatus: ISubscriptionProps | null) => {
  const {
    productFilters: products,
    regionFilters: regions,
    includedProductIds: productIds,
    includedRegionIds: regionIds,
  } = usePageFiltersContext();
  const [subscriptions, setSubscriptions] = useState(subscriptionStatus);

  useEffect(() => {
    setSubscriptions(subscriptionStatus);
  }, [subscriptionStatus?.subscriptionId]);

  const markSubscribed = useCallback(() => {
    setSubscriptions((prev) => (prev ? { ...prev, isSubscribed: true } : prev));
  }, []);

  const subscribeTexts = (status?): string => {
    if (!subscriptions) return '';
    const { isSubscribed } = subscriptions;
    return getSubscribeTexts({ isSubscribed, productIds, regionIds, products, regions }, status);
  };

  return {
    subscriptions,
    markSubscribed,
    subscribeButtonText: subscribeTexts(false),
    subscribeSuccessMessage: subscribeTexts(true),
  };
};
